import React, { memo } from 'react';
import { ShowMore } from '@yme/atoms/show-more';
import { useIsMount } from '@yme/hooks/index';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { ButtonLink } from '@yme/molecules/buttons';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { HeadingLevel2, HeadingLevel4, RegularTextLevel3 } from '@yme/tokens/typography';
import { getDescriptionLinesNumber } from './helpers';
import { CardStyled } from './styled';
function PromoCardComponent(props) {
    const { subtitle, title, description, buttonLabel, buttonLink } = props;
    const { isMobileView, isTabletView } = useWindowSize();
    const isMount = useIsMount();
    const descriptionLinesNumber = getDescriptionLinesNumber({
        isMobileView,
        isTabletView,
    });
    return (React.createElement(CardStyled, null,
        subtitle && (React.createElement(FlexWrapper, { pb: INDENT.xxxxs },
            React.createElement(HeadingLevel4, { color: colorCoreBlack300 }, subtitle))),
        React.createElement(FlexWrapper, { mb: INDENT.xs },
            React.createElement(HeadingLevel2, null, title)),
        description && !isMount && (React.createElement(ShowMore, { maxLinesCount: descriptionLinesNumber, bottomIndent: INDENT.sm, wrapper: RegularTextLevel3, textColor: colorCoreBlack300, buttonColor: colorCoreBlack300 }, description)),
        React.createElement(ButtonLink, { buttonLabel: buttonLabel, buttonLink: buttonLink })));
}
export const PromoCard = memo(PromoCardComponent);
PromoCard.displayName = 'PromoCard_Molecule';
